import { render, staticRenderFns } from "./ChatX2.vue?vue&type=template&id=8b59e1a0&"
import script from "./ChatX2.vue?vue&type=script&lang=js&"
export * from "./ChatX2.vue?vue&type=script&lang=js&"
import style0 from "./ChatX2.vue?vue&type=style&index=0&id=8b59e1a0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports